


















import { Component, Vue } from "vue-property-decorator";
import app from "@/store/app";

@Component
export default class LoggedIn extends Vue {
  public async logout() {
    try {
      const openID = Vue.$authentication.openID;
      if (!openID) return;

      app.SET_IS_LOADING(true);
      await Vue.$authentication.logout(openID);
      this.$router.push(`/login`, () => {
        app.SET_IS_LOADING(false);
      });
    } catch (error) {
      app.SET_IS_LOADING(false);
      //app.SET_HAS_ERROR();
    }
  }
}
